import { useState } from 'react';
import { useAnchorWallet, useConnection } from '@solana/wallet-adapter-react';
import { AnchorProvider, Idl, Program, setProvider } from "@coral-xyz/anchor";
import * as merkyIdl from "../idl/merky_v2.json";
import { AirdropData } from "../helpers/dataStructures";

export const useAirdropData = () => {
  const { connection } = useConnection();
  const wallet = useAnchorWallet()

  const [airdropData, setAirdropData] = useState<AirdropData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAirdropData = async () => {
    setIsLoading(true);
    setError(null);

    try {
      if (!wallet) {
        setError("Please connect your wallet.");
        return;
      }

      const provider = new AnchorProvider(connection, wallet, {});
      setProvider(provider);
      const program = new Program(merkyIdl as Idl, { connection });

      // @ts-ignore
      const airdropData = await program.account.merkleDistributor.all();

      const matchingAirdrops = airdropData
        .filter((data: any) => data.account.base.toBase58() === "kyd8ahxhHbxarcxLuuedURFuCQDCnSVxAhVwyCJtVmi");

      console.log(matchingAirdrops);

      if (matchingAirdrops.length > 0) {
        const data = matchingAirdrops[0];
        const formattedData: AirdropData = {
          mint: data.account.mint.toBase58(),
          base: data.account.base.toBase58(),
          tokenVault: data.account.tokenVault.toBase58(),
          maxTotalClaim: data.account.maxTotalClaim.toString(),
          maxNumNodes: data.account.maxNumNodes.toNumber(),
          totalAmountClaimed: data.account.totalAmountClaimed.toString(),
          numNodesClaimed: data.account.numNodesClaimed.toNumber(),
          startTs: data.account.startTs.toNumber(),
          endTs: data.account.endTs.toNumber(),
          clawbackStartTs: data.account.clawbackStartTs.toNumber(),
          clawbackReceiver: data.account.clawbackReceiver.toBase58(),
          admin: data.account.admin.toBase58(),
          clawedBack: data.account.clawedBack,
          closable: data.account.closable,
        };
        setAirdropData(formattedData);
      } else {
        setAirdropData(null);
      }
    } catch (error) {
      setError("Error fetching airdrop data. " + error)
    } finally {
      setIsLoading(false);
    }
  };

  return { airdropData, isLoading, error, fetchAirdropData };
};
